module.exports = __webpack_public_path__ + "static/media/tag.097ec414.svg";